module.exports = __webpack_public_path__ + "static/language-selector-screen1@3x-2c779a77cdf6fb8c67f462b5cc7beaef.png";